import React from 'react'
import PropTypes from 'prop-types'
import has from 'lodash/get'

import Logo from './Logo'
import * as scenes from '../scenes'

const LogoContainer = ({ settings, scene, showcaseNum }) => {
  const showcaseNumI = parseInt(showcaseNum)
  let image = settings.splash.logo
  let customClassName = 'ou_static-logo-intro'
  let id = 'ou_static-logo-intro'
  switch (scene) {
    case scenes.INTRO:
      if (settings.intro.logo) image = settings.intro.logo
      customClassName = 'ou_static-logo-intro'
      id = 'ou_static-logo-intro'
      break
    case scenes.VIDEO:
      if (settings.door.logo) image = settings.door.logo
      customClassName = 'ou_static-logo-video'
      id = 'ou_static-logo-video'
      break
    case scenes.SHOWCASE:
      if (showcaseNumI === settings.showcases.length + 1) { //redirect scene
        image = ''
        break
      }
      if (showcaseNumI === settings.showcases.length) { // last scene
        if (has(settings, 'lastScene.logo')) image = settings.lastScene.logo
        customClassName = `ou_static-logo-last-scene`
        id = `ou_static-logo-last-scene`
      } else {
        try {
          const showcase = settings.showcases[showcaseNumI]
          if (showcase.logo) image = showcase.logo
          const slideId = showcase.slideId ? showcase.slideId : showcaseNum
          customClassName = `ou_static-logo-showcase-${showcaseNum} ou_static-logo-showcase-p${slideId}`
          id = `ou_static-logo-showcase-${showcaseNum}`
        } catch (e) {
          console.warn('showcaseNum', showcaseNum, 'showcase', settings.showcases[showcaseNumI], 'showcases', settings.showcases)
          console.error(e)
        }
      }
      break
  }
  return (
    <Logo
      image={image}
      customClassName={customClassName}
      id={id}
    />
  )
}

LogoContainer.propTypes = {
  settings: PropTypes.object,
  scene: PropTypes.string,
  showcaseNum: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
}

export default LogoContainer



// WEBPACK FOOTER //
// ./src/templates/outSide/components/LogoContainer.js